import Ad from "@gik/ads/components/Ad";
import ZonesMap from "@gik/ads/maps/ZonesMap";
import { ArticleHeroSection } from "@gik/blog/components/ArticleHeroSection/ArticleHeroSection";
import { BlogHomepageFeaturedArticlesGrid } from "@gik/blog/components/BlogHomepageFeaturedArticlesGrid/BlogHomepageFeaturedArticlesGrid";
import { FeaturedArticlesSection } from "@gik/blog/components/FeaturedArticlesSection/FeaturedArticlesSection";
import { DynamicComponent } from "@gik/core/components/DynamicComponent";
import { withMeta } from "@gik/core/hocs/withMeta";
import { useBemCN } from "@gik/core/utils/bemBlock";
import { ArticleTile } from "@gik/ui-legacy/gik/ArticleTile";
import { PageSection } from "@gik/ui-legacy/gik/PageSection";
import React from "react";

const blockName = "blog-homepage";

export function BlogHomepage() {
	const bem = useBemCN(blockName);

	return withMeta(
		{
			title: "Blog",
			keywords:
				"how to be supportive, support a friend, support a family member",
			description:
				"Give InKind changes the way we give support during times of need. Read expert articles and guides" +
				" from those who have been there before.",
			thumbnailTitle: `Learn InKind: Read expert guides and personal stories about supporting loved ones through life's many different circumstances.`,
		},
		<article {...bem()}>
			<FeaturedArticlesSection {...bem("section-1")} />

			<DynamicComponent height={90}>
				<Ad
					zone={ZonesMap.BlogZones.Top}
					mobileZone={ZonesMap.BlogZones.TopMobile}
				/>
			</DynamicComponent>

			<PageSection {...bem("section-wrapper")}>
				<BlogHomepageFeaturedArticlesGrid slug="learn-page-row-2" perPage={4} />
			</PageSection>

			<PageSection {...bem("section-wrapper")}>
				<BlogHomepageFeaturedArticlesGrid slug="learn-page-row-3" perPage={2} />
			</PageSection>

			<DynamicComponent height={90}>
				<Ad
					zone={ZonesMap.BlogZones.Middle}
					mobileZone={ZonesMap.BlogZones.MiddleMobile}
				/>
			</DynamicComponent>

			<PageSection
				{...bem("section-4-5-wrapper", null, bem("section-wrapper").className)}
			>
				<BlogHomepageFeaturedArticlesGrid
					slug="learn-page-row-4-col-1"
					perPage={2}
				/>
				<BlogHomepageFeaturedArticlesGrid
					slug="learn-page-row-4-col-2"
					perPage={2}
				/>
			</PageSection>

			<ArticleHeroSection {...bem("article-hero")} />

			<DynamicComponent height={90}>
				<Ad
					zone={ZonesMap.BlogZones.Bottom}
					mobileZone={ZonesMap.BlogZones.BottomMobile}
				/>
			</DynamicComponent>
		</article>,
	);
}
const baseHomepageArticleTileFields = ArticleTile.requiredWPFields.filter(
	(field) => field != "excerpt.rendered",
);

BlogHomepage.requiredWPFields = {
	carouselArticles: baseHomepageArticleTileFields,
	latestArticles: baseHomepageArticleTileFields,
	featuredArticlesGrid: baseHomepageArticleTileFields,
	hero: baseHomepageArticleTileFields,
	featuredContent: ["slug", "acf.section_title"],
};
